import { FormField, FormInput, FormSelect } from "web-design-system";
import { GENDER } from "creso-core/constants";
import { getFieldLabel } from "creso-core/utils";
import { useCountryOptions } from "creso-core/hooks";
import { Section } from "./section";
import { useAccountForm } from "./context";

export function PersonalInformationSection() {
  const { form, isEditing } = useAccountForm();

  const countryOptions = useCountryOptions();

  const dirtyFields = Object.entries(form.formState.dirtyFields.profile || {})
    .filter(([, v]) => v)
    .map(([k]) => getFieldLabel(k));

  return (
    <Section dirtyFields={dirtyFields} defaultOpen title="Personal Information">
      <div className="grid gap-6 grid-cols-6">
        <FormField
          className="col-span-3 sm:col-span-6 md:col-span-3"
          control={form.control}
          name="profile.name"
          disabled
          render={({ field }) => <FormInput label="Name" {...field} />}
        />
        <FormField
          className="col-span-3 sm:col-span-6 md:col-span-3"
          control={form.control}
          name="profile.pan"
          disabled
          render={({ field }) => (
            <FormInput
              label="Pan"
              {...field}
              onChange={(val) => field.onChange(val?.toLocaleUpperCase())}
            />
          )}
        />
        <FormField
          className="col-span-6 md:col-span-2"
          control={form.control}
          name="profile.gender"
          render={({ field }) => (
            <FormSelect
              label="Gender"
              options={GENDER}
              disabled={!isEditing}
              {...field}
            />
          )}
        />
        <FormField
          className="col-span-6 md:col-span-2"
          control={form.control}
          name="profile.date_of_birth"
          render={({ field }) => (
            <FormInput
              {...field}
              label="Date of birth"
              type="date"
              placeholder="Select date"
              disabled={!isEditing}
            />
          )}
        />
        <FormField
          className="col-span-6 md:col-span-2"
          control={form.control}
          name="profile.country_of_birth"
          render={({ field }) => (
            <FormSelect
              {...field}
              label="Country of birth"
              placeholder="Select country"
              options={countryOptions}
              disabled={!isEditing}
            />
          )}
        />
      </div>
    </Section>
  );
}
